import { Component, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable, filter } from 'rxjs';
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { MatchValidator } from 'src/app/shared/validators/match-validator';
import { IProfile } from '../models/profile';
import { PersonalService } from '../services/personal.service';
import { EmployeeStoreService } from 'src/app/company/stores/employee-store.service';
import { AppStateInterface } from 'src/app/stores/appState.interface';
import { Store, select } from '@ngrx/store';
import { currentEmployeeSelector } from 'src/app/stores/global/current-employee/current-employee-selector';
import { TokenStorageService } from '../storage/token-storage.service';
import * as EmployeeActions from "./../../stores/global/employees/employee-actions";


@UntilDestroy()
@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit {
  public phoneNumberValue: string = "";
  public phoneNumberMask: string = "000-000-00-00";
  currentEmployee$: Observable<any>;


  public profileForm: UntypedFormGroup;
  public passwordForm: UntypedFormGroup = new UntypedFormGroup({
    password: new UntypedFormControl('', Validators.required),
    newPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
    confirmNewPassword: new UntypedFormControl('', Validators.required),
  }, [MatchValidator('newPassword','confirmNewPassword')])

  public profile : IProfile;

  get passwordMatchError() {
    return (
      this.passwordForm.getError('mismatch') &&
      this.passwordForm.get('confirmNewPassword')?.touched
    );
  }

  constructor(
    private route : ActivatedRoute,
    private personalService : PersonalService,
    private appnotificationService: AppNotificationService,
    private tokenStorageSerivce: TokenStorageService,
    private store: Store<AppStateInterface>
      ) {
        this.currentEmployee$ = this.store.pipe(select(currentEmployeeSelector));
      }

  public profile$ = new BehaviorSubject<IProfile>(null);

  ngOnInit(): void {
    this.profile$.next(this.route.snapshot.data['profile'] as IProfile);

    this.profileForm = new UntypedFormGroup({
      userName: new UntypedFormControl(this.profile$.getValue().userName, [Validators.required]),
      company: new UntypedFormControl(null),
      role: new UntypedFormControl(null),
      firstName: new UntypedFormControl(this.profile$.getValue().firstName, [Validators.required]),
      lastName: new UntypedFormControl(this.profile$.getValue().lastName, [Validators.required]),
      email: new UntypedFormControl(this.profile$.getValue().email, [
        Validators.required,
        Validators.email,
      ]),
      phoneNumber: new UntypedFormControl(this.profile$.getValue().phoneNumber)
    });

    this.initCurrentEmployee();

    this.currentEmployee$
    .pipe(untilDestroyed(this))
    .subscribe(employee => {
      this.profileForm.patchValue({
        company: employee.company?.name ?? '',
        role: employee.role ?? ''
      });
    });
  }

  initCurrentEmployee() {
    if (this.tokenStorageSerivce.getToken()) {
      this.store.dispatch(EmployeeActions.getCurrentEmployee());
    }
  }

  submitPasswordChange() {
    
    if (this.passwordForm.invalid) {
      return;
    }

    this.personalService.changePassword(this.passwordForm.getRawValue())
      .subscribe((): void => {
        this.appnotificationService.notification$.next({message: translate('profile.passwordUpdateSuccessful'),style:'success'})
      });
  }
}
